<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
};
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

html,
body,
#app {
    width: 100%;
}

/* .ivu-form-label-left .ivu-form-item-label {
        height: 42px !important;
    } */

.ivu-message-notice-content {
    padding: 16px 30px !important;
}

.ivu-message .ivu-icon {
    top: 3px !important;
    font-size: 24px !important;
}

.ivu-message {
    font-size: 15px !important;
    z-index: 9999 !important;
}

.ivu-modal-confirm-head-title {
    font-size: 17px !important;
}

.ivu-modal-confirm-body {
    font-size: 15px !important;
}

.ivu-input[disabled],
fieldset[disabled] .ivu-input {
    background-color: #fff !important;
}

.ivu-select-disabled .ivu-select-selection {
    background-color: #fff !important;
}

.ivu-modal {
    top: 20% !important;
}

.ivu-modal-mask {
    z-index: 3000 !important;
}

.ivu-modal-wrap {
    z-index: 3000 !important;
}

.ivu-modal-confirm-footer .ivu-btn-text {
    color: #fff !important;
    background-color: #2d8cf0 !important;
    border-color: #2d8cf0 !important;
    margin-right: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue